<template>
  <div class="px-4 py-3 pb-4 mobile:pb-6 flex flex-col mobile:flex-row mobile:flex-row-reverse gap-2 mobile:px-6 mobile:justify-center">
    <slot />
  </div>
</template>
